import { render, staticRenderFns } from "./dbugga.vue?vue&type=template&id=62d04c0e"
import script from "./dbugga.vue?vue&type=script&lang=js"
export * from "./dbugga.vue?vue&type=script&lang=js"
import style0 from "./dbugga.vue?vue&type=style&index=0&id=62d04c0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports